<div class="content-cell bordered">
    <kve-editor-input-header [title]="title" [toolTip]="toolTip"></kve-editor-input-header>
    <!-- <div class="content-cell bordered">
        <div class="cell-head"><span class="header-text">Current Values</span></div>
        <div class="cell-content current-values">
            <div class="value-label">Column width</div>
            <div class="value">1366px</div>
        </div>
    </div> -->
    <div class="content-cell">
        <div class="option-text">
            Select one of the following as primary colour.
        </div>
        <div class="cell-content pallette-options">
            <div *ngFor="let theme of themes" (click)="setTheme(theme)" class="button-wrapper" >
                <button [style.background-color]="theme.pallette" class="pallette-button"></button>
            </div>
        </div>
    </div>
</div>
